import { render } from "./SidelinkEntry.vue?vue&type=template&id=45c1ce23&scoped=true"
import script from "./SidelinkEntry.vue?vue&type=script&lang=js"
export * from "./SidelinkEntry.vue?vue&type=script&lang=js"

import "./SidelinkEntry.vue?vue&type=style&index=0&id=45c1ce23&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/acnh-tracker/acnh-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c1ce23"]])

export default __exports__